/* 🤖 this file was generated by script */
export const wiconAttachment02 = {
  name: 'attachment_02',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 5.26V16.5a5.5 5.5 0 11-11 0V5.67a3.67 3.67 0 017.33 0v10.78a1.83 1.83 0 11-3.66 0v-9.8"/></svg>`,
};
